import { useState} from 'react';
import Header from './Header';
import BurgerSlideMenu from './BurgerSlideMenu';
import Content from './Content';
import Footer from './Footer';    
import './App.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Contact from './Contact';
import Dogwalkers from './DogWalkers';
import FAQ from './Faq';


import ScrollToTop from './ScrollToTop';



function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);


  return (
    <Router>
      <ScrollToTop />
      <div id="App">

        <BurgerSlideMenu isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
        {/* <Header onBurgerClick={() => setIsMenuOpen(true)} /> */}
        <Header onBurgerClick={() => setIsMenuOpen(true)} isMenuOpen={isMenuOpen} />

        <Routes>

          <Route path="/" element={<Content />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/dogwalkers" element={<Dogwalkers />} />
          <Route path="/faq" element={<FAQ />} />
      
        </Routes>

        <Footer />

      </div>
    </Router>
  );
}

export default App;


